import React from "react";
import {
  FormControl,
  FormControlProps,
  Input,
  Box,
  Icon,
  FormLabel,
  FormErrorMessage,
  VisuallyHidden
} from "@chakra-ui/react";
import { IoCheckmarkOutline, IoCloseOutline } from "react-icons/io5";
import { useField } from "duck";
import { Types } from "../../duck";

interface SwitchProps extends Omit<Types.BaseInputProps, "inputLayoutProps"> {
  isChecked?: boolean;
  onChange?(checked: boolean): void;
  wrapperProps?: FormControlProps;
}

const Switch: React.FC<SwitchProps> = ({
  name,
  label,
  labelHidden,
  wrapperProps,
  isChecked,
  onChange: customOnChange
}) => {
  const { onChange: formOnChange, value, error } = useField(name);

  const resolvedChecked = isChecked === undefined ? value === true : isChecked;
  const onChange = customOnChange === undefined ? formOnChange : customOnChange;

  return (
    <FormControl display="flex" alignItems="center" {...wrapperProps}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={2}
        position="relative"
      >
        <Input
          type="checkbox"
          checked={resolvedChecked}
          onChange={event => {
            if (onChange) {
              onChange(event.target.checked);
            }
          }}
          onClick={() => {}}
          display="inline-block"
          appearance="none"
          cursor="pointer"
          height="20px"
          width="32px"
          backgroundColor={resolvedChecked ? "dark.500" : "gray.200"}
          borderRadius="full"
          style={{ border: "1px solid #313143" }}
        />
        <Box
          transition="all 0.2s ease-in"
          transform={resolvedChecked ? "translateX(15px)" : "translateX(0)"}
          position="absolute"
          cursor="pointer"
          top="2px"
          left="2px"
          w="16px"
          h="16px"
          borderRadius="full"
          border="1px solid"
          borderColor="dark.500"
          background="white"
          display="flex"
          justifyContent="center"
          alignItems="center"
          onClick={() => {
            if (onChange) {
              onChange(!resolvedChecked);
            }
          }}
        >
          <Icon
            as={resolvedChecked ? IoCheckmarkOutline : IoCloseOutline}
            w="10px"
            h="10px"
          />
        </Box>
      </Box>

      {label && labelHidden && <VisuallyHidden>{label}</VisuallyHidden>}
      {label && !labelHidden && (
        <FormLabel mb="0" ml={4} color="gray.700" _hover={{}}>
          {label}
        </FormLabel>
      )}

      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};

export default Switch;
